import { API_BASE_URL, API_CUSTOM_BASE_URL, API_LAUNDRITEK_URL } from "./apiURLConfig";

export const USER_API_URLS = {
  SEND_OTP: `${API_LAUNDRITEK_URL}.send_otp`,
  VERIFY_OTP: `${API_LAUNDRITEK_URL}.verify_otp`,
  REGISTER_USER: `${API_LAUNDRITEK_URL}.register_user`,
  LOGOUT_USER: `${API_LAUNDRITEK_URL}.logout_user`,
  GET_CURRENT_USER: `${API_LAUNDRITEK_URL}.get_current_user`,
  GET_ALL_USERS: `${API_LAUNDRITEK_URL}.get_users`,
  GET_USER_BY_ID: `${API_LAUNDRITEK_URL}.get_user`,
  CREATE_USER: `${API_LAUNDRITEK_URL}.create_user`,
  UPDATE_USER: `${API_LAUNDRITEK_URL}.update_user`,
  DELETE_USER: `${API_LAUNDRITEK_URL}.delete_user`,
  GET_ALL_ACTIVITY_LOGS: `${API_LAUNDRITEK_URL}.get_activity_logs`,
};

export const ORGANIZATION_API_URLS = {
  GET_ALL_ORGANIZATIONS: `${API_LAUNDRITEK_URL}.get_organizations`,
  /** No single-item endpoint — service filters the list by name. */
  GET_ORGANIZATION_BY_ID: `${API_LAUNDRITEK_URL}.get_organizations`,
  CREATE_ORGANIZATION: `${API_LAUNDRITEK_URL}.create_organization`,
  UPDATE_ORGANIZATION: `${API_LAUNDRITEK_URL}.update_organization`,
  DELETE_ORGANIZATION: `${API_LAUNDRITEK_URL}.delete_organization`,
};

export const VOUCHER_API_URLS = {
  GET_ALL_VOUCHERS: `${API_LAUNDRITEK_URL}.get_vouchers`,
  /** Voucher mutations not in new API — kept on legacy resource endpoints. */
  CREATE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/`,
  UPDATE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/:name`,
  DELETE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/:name`,
  GET_VOUCHER_BY_ID: `${API_BASE_URL}/api/resource/Voucher/:name`,
};

export const COUPON_API_URLS = {
  GET_ALL_COUPONS: `${API_LAUNDRITEK_URL}.get_coupons`,
  GET_MY_COUPONS: `${API_LAUNDRITEK_URL}.get_my_coupons`,
  VALIDATE_COUPON_CODE: `${API_LAUNDRITEK_URL}.validate_coupon_code`,
  CREATE_COUPON: `${API_LAUNDRITEK_URL}.create_coupon`,
  UPDATE_COUPON: `${API_LAUNDRITEK_URL}.update_coupon`,
  DEACTIVATE_COUPON: `${API_LAUNDRITEK_URL}.deactivate_coupon`,
  DELETE_COUPON: `${API_LAUNDRITEK_URL}.delete_coupon`,
};

export const SHOP_API_URLS = {
  GET_ALL_SHOPS: `${API_LAUNDRITEK_URL}.get_shops`,
  GET_SHOP_BY_ID: `${API_LAUNDRITEK_URL}.get_shop`,
  CREATE_SHOP: `${API_LAUNDRITEK_URL}.create_shop`,
  UPDATE_SHOP: `${API_LAUNDRITEK_URL}.update_shop`,
  DELETE_SHOP: `${API_LAUNDRITEK_URL}.delete_shop`,
};

export const MACHINE_API_URLS = {
  GET_ALL_MACHINES: `${API_LAUNDRITEK_URL}.get_machines`,
  GET_MACHINE_BY_ID: `${API_LAUNDRITEK_URL}.get_machine`,
  GET_MACHINE_BY_DEVICE_EUI: `${API_LAUNDRITEK_URL}.get_machine_by_device_eui`,
  GET_ALL_MACHINES_AND_PRICES: `${API_LAUNDRITEK_URL}.get_machines_with_prices`,
  GET_DEVICE_LOG: `${API_LAUNDRITEK_URL}.get_device_log`,
  CREATE_MACHINE: `${API_LAUNDRITEK_URL}.create_machine`,
  UPDATE_MACHINE: `${API_LAUNDRITEK_URL}.update_machine`,
  DELETE_MACHINE: `${API_LAUNDRITEK_URL}.delete_machine`,
};

export const MACHINE_MODEL_API_URLS = {
  GET_ALL_MACHINE_MODELS: `${API_LAUNDRITEK_URL}.get_machine_models`,
  GET_MACHINE_MODEL_BY_ID: `${API_LAUNDRITEK_URL}.get_machine_model`,
  CREATE_MACHINE_MODEL: `${API_LAUNDRITEK_URL}.create_machine_model`,
  UPDATE_MACHINE_MODEL: `${API_LAUNDRITEK_URL}.update_machine_model`,
  DELETE_MACHINE_MODEL: `${API_LAUNDRITEK_URL}.delete_machine_model`,
};

export const MACHINE_DEVICE_API_URLS = {
  GET_ALL_MACHINE_DEVICES: `${API_LAUNDRITEK_URL}.get_machine_devices`,
  GET_MACHINE_DEVICE_BY_ID: `${API_LAUNDRITEK_URL}.get_machine_device`,
  CREATE_MACHINE_DEVICE: `${API_LAUNDRITEK_URL}.create_machine_device`,
  UPDATE_MACHINE_DEVICE: `${API_LAUNDRITEK_URL}.update_machine_device`,
  DELETE_MACHINE_DEVICE: `${API_LAUNDRITEK_URL}.delete_machine_device`,
};

export const COMMAND_API_URLS = {
  GET_ALL_COMMANDS: `${API_LAUNDRITEK_URL}.get_commands`,
  CREATE_COMMAND: `${API_LAUNDRITEK_URL}.create_command`,
  /** Command update/delete/single not in new API — kept on legacy resource endpoints. */
  UPDATE_COMMAND: `${API_BASE_URL}/api/resource/Command API/:name`,
  DELETE_COMMAND: `${API_BASE_URL}/api/resource/Command API/:name`,
  GET_COMMAND_BY_ID: `${API_BASE_URL}/api/resource/Command API/:name`,
};

export const STATE_API_URLS = {
  GET_ALL_STATES: `${API_LAUNDRITEK_URL}.get_states`,
  /** State mutations not in new API — kept on legacy resource endpoints. */
  GET_STATE_BY_ID: `${API_BASE_URL}/api/resource/State/:name`,
  CREATE_STATE: `${API_BASE_URL}/api/resource/State/`,
  UPDATE_STATE: `${API_BASE_URL}/api/resource/State/:name`,
  DELETE_STATE: `${API_BASE_URL}/api/resource/State/:name`,
};

export const DISTRICT_API_URLS = {
  GET_ALL_DISTRICTS: `${API_LAUNDRITEK_URL}.get_districts`,
  /** District mutations not in new API — kept on legacy resource endpoints. */
  GET_DISTRICT_BY_ID: `${API_BASE_URL}/api/resource/District/:name`,
  GET_DISTRICTS_BY_STATE: `${API_LAUNDRITEK_URL}.get_districts`,
  CREATE_DISTRICT: `${API_BASE_URL}/api/resource/District/`,
  UPDATE_DISTRICT: `${API_BASE_URL}/api/resource/District/:name`,
  DELETE_DISTRICT: `${API_BASE_URL}/api/resource/District/:name`,
};

/** Order doctype */
export const ORDER_API_URLS = {
  GET_ALL_ORDERS: `${API_LAUNDRITEK_URL}.get_transactions`,
  GET_MY_ORDERS: `${API_LAUNDRITEK_URL}.get_my_orders`,
  GET_ORDER_BY_ID: `${API_LAUNDRITEK_URL}.get_transaction`,
  CREATE_ORDER: `${API_LAUNDRITEK_URL}.create_transaction`,
};

/** @deprecated Use ORDER_API_URLS — kept for compatibility. */
export const TRANSACTION_API_URLS = {
  GET_ALL_TRANSACTIONS: ORDER_API_URLS.GET_ALL_ORDERS,
  CREATE_TRANSACTION: ORDER_API_URLS.CREATE_ORDER,
  GET_TRANSACTION_BY_ID: ORDER_API_URLS.GET_ORDER_BY_ID,
  GET_TRANSACTIONS_FOR_USER: ORDER_API_URLS.GET_MY_ORDERS,
};

export const ISSUE_API_URLS = {
  GET_ALL_ISSUES: `${API_LAUNDRITEK_URL}.get_issues`,
  GET_ALL_ISSUE_TYPES: `${API_LAUNDRITEK_URL}.get_issue_types`,
  CREATE_ISSUE: `${API_LAUNDRITEK_URL}.create_issue`,
  UPDATE_ISSUE: `${API_LAUNDRITEK_URL}.update_issue`,
  DELETE_ISSUE: `${API_LAUNDRITEK_URL}.delete_issue`,
  /** No single-issue endpoint in new API — kept on legacy resource. */
  GET_ISSUE_BY_ID: `${API_BASE_URL}/api/resource/Issue/:name`,
  /** Frappe file upload — multipart; not in new API. */
  UPLOAD_FILE: `${API_BASE_URL}/api/method/upload_file`,
};

export const REFUND_API_URLS = {
  REQUEST_REFUND: `${API_LAUNDRITEK_URL}.request_refund`,
  GET_ALL_REFUND_REQUESTS: `${API_LAUNDRITEK_URL}.get_refund_requests`,
  /** No single-refund endpoint — service filters the list by name. */
  GET_REFUND_REQUEST_BY_ID: `${API_LAUNDRITEK_URL}.get_refund_requests`,
  CREATE_REFUND_REQUEST: `${API_LAUNDRITEK_URL}.request_refund`,
  UPDATE_REFUND_REQUEST: `${API_LAUNDRITEK_URL}.update_refund_request`,
  /** No delete in new API — kept on legacy resource. */
  DELETE_REFUND_REQUEST: `${API_BASE_URL}/api/resource/Refund Request/:name`,
};

/** Payment API — entirely in laundritek.api_payment; not in the new laundritek.api. */
export const PAYMENT_API_URLS = {
  MAKE_ORDER: `${API_CUSTOM_BASE_URL}/laundritek.api_payment.make_order`,
  GET_ALL_PAYMENT_TYPES: `${API_BASE_URL}/api/resource/Payment Type?fields=["*"]&limit_page_length=0`,
  GET_ALL_PAYMENT_GATEWAYS: `${API_BASE_URL}/api/resource/Payment Gateway?fields=["*"]&limit_page_length=0`,
  GET_SHOP_PAYMENT_SETTINGS: `${API_BASE_URL}/api/resource/Shop/:name`,
  UPDATE_ORDER: `${API_BASE_URL}/api/resource/Order/:name`,
  CANCEL_ORDER: `${API_BASE_URL}/api/resource/Order/:name`,
  GET_SHOP_PAYMENT_SETTINGS_BY_ID: `${API_CUSTOM_BASE_URL}/laundritek.api_payment.get_payment_gateway_settings`,
  GET_ORDER_PROGRESS: `${API_CUSTOM_BASE_URL}/laundritek.api_payment.get_order_progress`,
};
